export const S3_BASE_URL = `https://${process.env.REACT_APP_AWS_BUCKET_NAME || "coxlawprodbucket"}.s3.${process.env.REACT_APP_AWS_REGION || "us-east-1"}.amazonaws.com`;

const S3_PREFIX_REGEX =
  /^https:\/\/[a-z0-9.-]+\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com\//i;

export function stripS3Prefix(url: string): string {
  if (!url || typeof url !== "string") return url;
  return url.replace(S3_PREFIX_REGEX, "");
}

export function getS3Url(path: string): string {
  if (!path || typeof path !== "string") return path;
  if (path.startsWith("http")) return path;
  return `${S3_BASE_URL}/${path}`;
}
